import { PaidAccountModel, PaidAccountResponse } from 'app/gamma/src/types';

import genericNormalizer from './generic';

export const normalizePaidAccount = genericNormalizer<
  PaidAccountResponse,
  PaidAccountModel
>(({ from }) => ({
  standing: from('standing'),
}));
